import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Zap } from 'lucide-react';
const generic = ['Videos grabados genéricos', 'Teoría sin aplicación real', 'Sin ayuda ni soporte', 'Sin práctica concreta', 'Sin comunidad de alumnos', 'Contenido desactualizado', 'No hay seguimiento del docente', 'Te quedás con dudas sin resolver'];
const academy = ['Experiencia real en obra', 'Normativa AEA vigente', 'Clases en vivo con docente', 'Acompañamiento personalizado', 'Comunidad activa de alumnos', 'Criterio profesional aplicado', 'Instalaciones reales en viviendas', 'Actualizaciones permanentes'];
export function Comparison() {
  return <section id="comparativa" className="py-24 bg-ed-darker relative border-t border-white/5 overflow-hidden" data-id="element-101">
      <div className="absolute inset-0 bg-radial-green-center opacity-20 pointer-events-none" data-id="element-102"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-103">
        <div className="text-center mb-14 max-w-2xl mx-auto" data-id="element-104">
          <span className="text-ed-green font-bold tracking-widest uppercase text-sm mb-3 block" data-id="element-105">
            Comparativa
          </span>
          <h2 className="text-4xl sm:text-5xl font-black uppercase tracking-tight text-white mb-4" data-id="element-106">
            ¿Por qué esta formación <br className="hidden sm:block" data-id="element-107" />
            es <span className="text-ed-green" data-id="element-108">diferente?</span>
          </h2>
          <p className="text-zinc-400 text-lg" data-id="element-109">
            No es otro curso más de internet. Es una academia profesional con
            estructura, criterio y acompañamiento real.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8 items-stretch" data-id="element-110">
          {/* Generic course */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="bg-ed-dark/60 border border-zinc-800 rounded-3xl p-8 sm:p-10 relative opacity-90" data-id="element-111">
            <div className="mb-6" data-id="element-112">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-500/10 border border-red-500/30 mb-4" data-id="element-113">
                <X className="w-3.5 h-3.5 text-red-400" strokeWidth={3} data-id="element-114" />
                <span className="text-xs font-black tracking-widest text-red-400 uppercase" data-id="element-115">
                  Curso común
                </span>
              </div>
              <h3 className="text-2xl font-black text-zinc-300 uppercase leading-tight" data-id="element-116">
                Curso genérico de internet
              </h3>
            </div>

            <ul className="space-y-3.5" data-id="element-117">
              {generic.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: -10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.3,
              delay: 0.1 + i * 0.05
            }} className="flex items-start gap-3" data-id="element-118">
                  <div className="w-5 h-5 rounded-md bg-red-500/10 border border-red-500/30 flex items-center justify-center shrink-0 mt-0.5" data-id="element-119">
                    <X className="w-3 h-3 text-red-400" strokeWidth={3} data-id="element-120" />
                  </div>
                  <span className="text-zinc-500 text-sm leading-snug line-through" data-id="element-121">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>

          {/* Academy ED */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6,
          delay: 0.15
        }} className="bg-gradient-to-b from-ed-dark to-ed-darker border-2 border-ed-green rounded-3xl p-8 sm:p-10 relative shadow-[0_0_60px_rgba(163,255,18,0.2)]" data-id="element-122">
            <div className="absolute -top-3.5 right-6" data-id="element-123">
              <div className="inline-flex items-center gap-1.5 px-4 py-1.5 rounded-full bg-ed-green text-ed-black text-xs font-black uppercase tracking-widest shadow-[0_0_20px_rgba(163,255,18,0.5)]" data-id="element-124">
                <Zap className="w-3.5 h-3.5" fill="currentColor" data-id="element-125" />
                La diferencia
              </div>
            </div>

            <div className="mb-6" data-id="element-126">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-ed-green/15 border border-ed-green/40 mb-4" data-id="element-127">
                <Check className="w-3.5 h-3.5 text-ed-green" strokeWidth={3} data-id="element-128" />
                <span className="text-xs font-black tracking-widest text-ed-green uppercase" data-id="element-129">
                  Academia ED
                </span>
              </div>
              <h3 className="text-2xl font-black text-white uppercase leading-tight" data-id="element-130">
                Formación profesional real
              </h3>
            </div>

            <ul className="space-y-3.5" data-id="element-131">
              {academy.map((item, i) => <motion.li key={i} initial={{
              opacity: 0,
              x: 10
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true,
              margin: '-50px'
            }} transition={{
              duration: 0.3,
              delay: 0.2 + i * 0.05
            }} className="flex items-start gap-3" data-id="element-132">
                  <div className="w-5 h-5 rounded-md bg-ed-green/15 border border-ed-green/40 flex items-center justify-center shrink-0 mt-0.5" data-id="element-133">
                    <Check className="w-3 h-3 text-ed-green" strokeWidth={3} data-id="element-134" />
                  </div>
                  <span className="text-white text-sm leading-snug font-medium" data-id="element-135">
                    {item}
                  </span>
                </motion.li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}